import { CommonModule, DatePipe } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'ngx-days-filter',
  templateUrl: './days-filter.component.html',
  styleUrls: ['./days-filter.component.scss'],
  imports: [CommonModule, FormsModule]
})
export class DaysFilterComponent implements OnInit {
  protected readonly datePipe = inject(DatePipe)
  protected readonly dialogRef = inject(MatDialogRef<DaysFilterComponent>)
  protected readonly data = inject(MAT_DIALOG_DATA)

  // Array to store the list of days derived from event timings.
  days: string[] = []

  // Array to store the currently selected days.
  selectedDays: string[] = []

  // Variable to store the selected status (default is 'yes').
  selectedStatus = 'yes'

  constructor() {}

  ngOnInit(): void {
    // Populate the `days` array with formatted dates from event timings.
    this.data.event['event_timings'].forEach((eventTime: any) => {
      this.days.push(this.datePipe.transform(eventTime.start_datetime, 'yyyy-MM-dd'))
    })

    // Initialize the selected days and status from the provided data.
    this.selectedDays = this.data.selectedDays
    this.selectedStatus = this.data.selectedStatus
  }

  /**
   * Toggles the selection of a day based on the checkbox state.
   * @param day - The day being toggled.
   * @param event - The event object to determine the checkbox state.
   */
  toggleDay(day: string, event: any): void {
    if (event.target.checked) {
      // Add the day to the selectedDays array if the checkbox is checked.
      this.selectedDays.push(day)
    } else {
      // Remove the day from the selectedDays array if the checkbox is unchecked.
      this.selectedDays = this.selectedDays.filter((d) => d !== day)
    }
  }

  /**
   * Closes the dialog and passes the selected days and status back to the parent.
   */
  applyFilter(): void {
    this.dialogRef.close({ days: this.selectedDays, status: this.selectedStatus })
  }
}
